import React from 'react';
import axios from "axios";
import Sidebar from '../reusable/Sidebar';
import parse from 'html-react-parser';
const GLOBAL = require('../../commonConstants.js');
const assetUrl = GLOBAL.assetUrl;
const isgf_team = GLOBAL.BASE_URL+"isgf-team";
function SecretariatTeam() {
  const [getTeam, setTeam] = React.useState(null);
  React.useEffect(() => {
    axios.get(isgf_team).then((response) => {
    setTeam(response.data);
     });
   },[]);
  
  if (!getTeam) return null;
  return (
    <>
<section className="isgf-breadcum isgf_board_of_governors_breadcum" style={{
                  backgroundImage: `url(${
                    process.env.PUBLIC_URL + "/images/board-of-governors/board-of-governors.jpg"
                  })`,
                }}>
	<div className="container">
		<div className="isgf-breadcum-box">
					<h1>ISGF Team</h1>
					<p>Home {'>'} ISGF {'>'} ISGF Organizational Structure {'>'} ISGF Team</p>
				</div>
	</div>
</section>
<section className="secretariat-team">
	<div className="container">
		<div className="row">
			<div className="col-lg-8">
				
				<div className="row">
					<div className="col-md-12">
						<div className="benefits_membership">
							<div className="heading mb-3">
			                	<h2>ISGF Team</h2>
			            	</div>
				            <div className="mb-3">
				       			
				       			<div className="row g-4">
                   {(getTeam) && getTeam.map((data,index)=>(
				       				<div className="col-sm-6 col-md-4" key={index}>
				       					<div className="isgf-team">
											<div className='image'>
													<img
														src={assetUrl + "/public/forum_img/" + data.image}
														alt="pic"
														style={{ width: '150px', height: '150px', objectFit: 'cover', borderRadius: '50%' }}
													/>
												</div>
											<div className='about-team'>
												<div className='name'>{data.title} </div>
												<div className='description'>{data.designation}</div>
											</div>

											<div className="social">
												{((data.twitter !== null) && (data.twitter !== '#')) ? (
													<a target="_blank" rel="noreferrer noopener" href={data.twitter} aria-label={`Twitter/X: ${data.title}`} style={{ color: 'inherit' }}>
														<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="18" height="18" aria-hidden="true" focusable="false" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
															<path fill="currentColor" d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"></path>
														</svg>
													</a>
												) : (
													<span aria-hidden="true" style={{ display: 'inline-block', opacity: 0.45 }}>
														<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="18" height="18" aria-hidden="true" focusable="false" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
															<path fill="currentColor" d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"></path>
														</svg>
													</span>
												)}
												{((data.linked_in !== null) && (data.linked_in !== '#')) ? (
													<a target="_blank" rel="noreferrer noopener" href={data.linked_in} className="fa fa-linkedin" aria-label={`LinkedIn: ${data.title}`}></a>
												) : (
													<span className="fa fa-linkedin disabled" aria-hidden="true"></span>
												)}
											</div>
											<div className="email-box">
												<a href={"mailto:" + data.email}><i className='fa fa-envelope'></i> {data.email}</a>
											</div>
											<div className='view' data-bs-toggle="modal" data-bs-target={`#collapseOne${index}`}>View Bio</div>
											
				       						
											{/* <div className='view' data-bs-toggle="modal" data-bs-target={`#collapseOne${index}`}>View Bio</div> */}
				       						
				       						{/* <div className="social">
				       						{((data.twitter != null) && (data.twitter != '#'))  ? <>
                                                            <a target="_blank" href={data.twitter}>
													<i className='fa fa-twitter media_icon'></i></a>  </>: <><a   href="" className="disabled">
													<i className='fa fa-twitter media_icon'></i></a> </>}
											 		{((data.linked_in != null) && (data.twitter != '#'))  ? <>
                          <a target="_blank" href={data.linked_in} >
													<i className='fa fa-linkedin media_icon'></i>
												</a>  </>: <> <a   href=""className="disabled"><i className='fa fa-linkedin media_icon'></i>
												</a></>}
				       							
											</div> */}
											{/* <div className="social">
											{((data.twitter != null) && (data.twitter !== '#')) ? (
											<a
											target="_blank"
											href={data.twitter}
											style={{ color: 'black' }}
											className='fa'
											>
											<svg
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 512 512"
											style={{ width: '20px', height: '20px', fill: 'white' }}
											>
											<path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
											</svg>
											</a>
											) : (
											<a href="" className="fa disabled" style={{ color: 'black' }}>
											<svg
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 512 512"
											style={{ width: '20px', height: '20px', fill: 'white', opacity: 0.5 }}
											>
											<path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
											</svg>
											</a>
											)}

											{((data.linked_in != null) && (data.linked_in !== '#')) ? (
											<a
											target="_blank"
											href={data.linked_in}
											className="fa fa-linkedin"
											></a>
											) : (
											<a href="" className="fa fa-linkedin disabled"></a>
											)}
											</div>
											<div className="email-box">
				       							<a href={"mailto:" + data.email} ><i className='fa fa-envelope'></i> {data.email}</a>
				       						</div> */}
				       						
				       						
				       					</div>
				       					
											<div className="modal fade" id={`collapseOne${index}`}  tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
																						<div className="modal-dialog" style={{ width: '70vw', maxWidth: '900px' }}>
																						<div className="modal-content" style={{ borderRadius: 10, padding: 18, boxShadow: '0 8px 24px rgba(0,0,0,0.12)' }}>
      
																							<div className="modal-body">
																							 	<div className="text-center">
																							 		<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" style={{ position: 'absolute', right: 18, top: 18 }}></button>
																							 		<img
																										src={assetUrl + "/public/forum_img/" + data.image}
																										alt={data.title || ''}
																										className="img-fluid mt-4"
																										style={{ width: '180px', height: '180px', objectFit: 'cover', borderRadius: '50%' }}
																								/>
											 							<h3 className="mt-3">{data.title}</h3>
																			<div>{data.designation}</div>
																			<div className="icon" style={{ marginTop: 8 }}>

																													   {((data.twitter !== null) && (data.twitter !== '#')) ? (
																																		<a target="_blank" rel="noreferrer noopener" href={data.twitter} aria-label={`Twitter/X: ${data.title}`} style={{ color: 'inherit', marginRight: 8 }}>
																																			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="20" height="20" aria-hidden="true" focusable="false" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
																																				<path fill="currentColor" d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"></path>
																																			</svg>
																																		</a>
																														   ) : (
																																		<span aria-hidden="true" style={{ marginRight: 8, opacity: 0.45 }}>
																																			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="20" height="20" aria-hidden="true" focusable="false" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
																																				<path fill="currentColor" d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"></path>
																																			</svg>
																																		</span>
																														   )}
																													 {((data.linked_in !== null) && (data.linked_in !== '#')) ? (
																																				<a target="_blank" rel="noreferrer noopener" href={data.linked_in} className="fa fa-linkedin" aria-label={`LinkedIn: ${data.title}`}></a>
																													 ) : (
																																				<span className="fa fa-linkedin disabled" aria-hidden="true"></span>
																													 )}
                                								
																												</div>
																			<a href={"mailto:" + data.email} className="btn btn-blue mt-3 mb-3">{data.email}</a>
																							 	</div>

																								<div style={{ maxWidth: 760, margin: '18px auto 0', textAlign: 'left', lineHeight: 1.6 }}>
																										{parse(`${data.bio}`)}
																								</div>
																							</div>

																						</div>
																					</div>
											</div>
				       				</div>
                  		))}
  
				       				
				       			</div>
							</div>
							
						</div>
					</div>
				</div>
				
			</div>
		    <div className="col-lg-4">
		    	<Sidebar/>
		    </div>
	</div>
    </div>
</section>

    </>
  )
}

export default SecretariatTeam